import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import Entry from '@/views/Entry'
import Interview from '@/views/Interview'
import Award from '@/views/Award'
import Top from '@/views/Top'
import Recommend from '@/views/Recommend'
import TopList from '@/views/Top100'
import Exhibition from '@/views/Exhibition'
import Qa from '@/views/Qa'
import Login from '@/views/Login'
import Regist from '@/views/Regist'
import Post from '@/views/Post'
import Work from '@/views/Work'
import WorkDetail from '@/views/WorkDetail'
import WorkDetailUpdate from '@/views/WorkDetailUpdate'
import User from '@/views/User'
import ChangeInfo from '@/views/ChangeInfo'
import UserChangePwd from '@/views/UserChangePwd'
import ForgetPwd from '@/views/ForgetPwd'


Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/', 
      redirect: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/entry',
      name: 'entry',
      component: Entry 
    },
    {
      path: '/interview',
      name: 'interview',
      component: Interview
    },
    {
      path: '/award',
      name: 'award',
      component: Award 
    },
    {
      path: '/toplist',
      name: 'toplist',
      component: TopList
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: Recommend 
    },
 
    {
      path: '/top',
      name: 'top',
      component: Top 
    },
    {
      path: '/exhibition',
      name: 'exhibition',
      component: Exhibition 
    },
    {
      path: '/exhibition/:id',
      name: 'exhibition',
     component: Exhibition 
    },
    {
      path: '/qa',
      name: 'qa',
      component: Qa 
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/regist',
      name: 'Regist',
      component: Regist
    },
    {
      path: '/post',
      name: 'Post',
      component: Post
    },
    {
      path: '/work',
      name: 'Work',
      component: Work
    },
    {
      path: '/workdetail/:id',
      name: 'WorkDetail',
      component: WorkDetail
    },
    {
      path: '/workdetailupdate/:id',
      name: 'WorkDetailUpdate',
      component: WorkDetailUpdate
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/changeInfo',
      name: 'ChangeInfo',
      component: ChangeInfo
    },
    {
      path: '/userchangepwd',
      name: 'UserChangePwd',
      component: UserChangePwd
    },
    {
      path: '/forgetpwd',
      name: 'ForgetPwd',
      component: ForgetPwd
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js